import { render, staticRenderFns } from "./UnsuccessfulTable.vue?vue&type=template&id=12258a38&scoped=true&"
import script from "./UnsuccessfulTable.vue?vue&type=script&lang=js&"
export * from "./UnsuccessfulTable.vue?vue&type=script&lang=js&"
import style0 from "./UnsuccessfulTable.vue?vue&type=style&index=0&id=12258a38&lang=sass&scoped=true&"
import style1 from "./UnsuccessfulTable.vue?vue&type=style&index=1&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12258a38",
  null
  
)

export default component.exports